import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useTheme } from '@mui/material';

export default function ConfirmDialog({ text, confirmBtnText, cancelBtnText, onConfirm, onCancel }: { text: string, confirmBtnText?: string, cancelBtnText?: string, onConfirm: () => void, onCancel: () => void }) {
    const theme = useTheme();

    return (
        <Dialog
            open={true}
            onClose={onCancel}
            sx={{ maxHeight:'95vh' }}
        >
            <DialogTitle sx={{ p: 0, pl: 1, color: 'white', backgroundColor: theme.palette.warning.main }} >Подтверждение</DialogTitle>
            <DialogContent sx={{ display: 'flex', justifyContent: 'center', textAlign: 'center', p: 0, m:1, mt:6, mb:2, minWidth: 300 }}>
                {text}
            </DialogContent>

            <DialogActions sx={{ textAlign: 'center', margin: ' 0 auto' }}>
                <Button onClick={onConfirm}>{confirmBtnText ?? 'Да'}</Button>
                <Button onClick={onCancel}>{cancelBtnText ?? 'Нет'}</Button>
            </DialogActions>
        </Dialog>
    );
}